import { useState } from "react";

const FORM_ACTION = "https://readdy.ai/api/form/db90js9rh5tg6sock1vg";

export default function FeedbackForm() {
  const [status, setStatus] = useState<"idle" | "submitting" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    // 反垃圾：蜜罐字段被填写则静默处理，不发送请求
    const honeypot = String(formData.get("website_alt") ?? "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("感谢你的反馈，我们会尽快处理。");
      form.reset();
      return;
    }

    const payload = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key === "website_alt") return;
      const str = String(value);
      if (str.trim() === "") return;
      payload.append(key, str);
    });

    setStatus("submitting");
    setMessage("");
    try {
      const response = await fetch(FORM_ACTION, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await response.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message || parsed?.meta?.detail || parsed?.code || responseText;
      const isSpam = typeof serverMsg === "string" && serverMsg.toLowerCase().includes("spam");
      const success = response.ok && parsed?.code === "OK" && !isSpam;

      if (success) {
        setStatus("success");
        setMessage("提交成功，感谢你的反馈，我们会尽快回复。");
        form.reset();
      } else {
        setStatus("error");
        setMessage(
          typeof serverMsg === "string" && serverMsg
            ? `提交失败：${serverMsg}`
            : "提交失败，请稍后重试或通过邮箱联系我们。",
        );
      }
    } catch {
      setStatus("error");
      setMessage("提交失败，网络异常，请稍后重试或通过邮箱联系我们。");
    }
  };

  return (
    <form data-readdy-form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label htmlFor="feedback-name" className="mb-1.5 block text-sm font-medium text-foreground-800">
          你的姓名 <span className="text-accent-600">*</span>
        </label>
        <input
          id="feedback-name"
          name="name"
          type="text"
          required
          placeholder="请输入你的姓名"
          className="w-full rounded-md border border-background-300 bg-background-100 px-4 py-2.5 text-sm text-foreground-800 outline-none transition-colors focus:border-primary-400 placeholder:text-foreground-400"
        />
      </div>

      <div>
        <label htmlFor="feedback-email" className="mb-1.5 block text-sm font-medium text-foreground-800">
          邮箱地址 <span className="text-accent-600">*</span>
        </label>
        <input
          id="feedback-email"
          name="email"
          type="email"
          required
          placeholder="用于接收我们的回复"
          className="w-full rounded-md border border-background-300 bg-background-100 px-4 py-2.5 text-sm text-foreground-800 outline-none transition-colors focus:border-primary-400 placeholder:text-foreground-400"
        />
      </div>

      <div>
        <label htmlFor="feedback-message" className="mb-1.5 block text-sm font-medium text-foreground-800">
          留言内容 <span className="text-accent-600">*</span>
        </label>
        <textarea
          id="feedback-message"
          name="message"
          required
          maxLength={500}
          rows={5}
          placeholder="欢迎提供新闻线索、问题反馈或合作意向（最多 500 字）"
          className="w-full resize-none rounded-md border border-background-300 bg-background-100 px-4 py-2.5 text-sm text-foreground-800 outline-none transition-colors focus:border-primary-400 placeholder:text-foreground-400"
        ></textarea>
      </div>

      <input
        className="sp-field-sink"
        type="text"
        name="website_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />

      <button
        type="submit"
        disabled={status === "submitting"}
        className="w-full cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
      >
        {status === "submitting" ? "提交中..." : "提交反馈"}
      </button>

      {status === "success" && (
        <p className="flex items-center gap-2 rounded-md bg-primary-50 px-4 py-3 text-sm text-primary-700">
          <i className="ri-checkbox-circle-line"></i>
          {message}
        </p>
      )}
      {status === "error" && (
        <p className="flex items-center gap-2 rounded-md bg-accent-50 px-4 py-3 text-sm text-accent-700">
          <i className="ri-error-warning-line"></i>
          {message}
        </p>
      )}
    </form>
  );
}